import { useState, useEffect, useContext } from "react";
import axios from "axios";
import AddRole from "../Role/AddRole";
import EditRole from "../Role/EditRole";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Context/AuthContext";
import { Authorization } from "../../../Context/Authorization";
import TableComponent from "../../../utils/TableComponent";

const ManageRole = () => {
  const [roles, setRoles] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentRole, setCurrentRole] = useState(null);
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const Confiq = Authorization();
        const response = await axios.get(`${Api}/api/users/roles`, Confiq);
        setRoles(response.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchRoles();
  }, [Api]);

  const handleShowAddPopup = () => { setShowAddPopup(true); };
  const handleCloseAddPopup = () => { setShowAddPopup(false); };

  const handleShowEditPopup = (role) => {
    setCurrentRole(role);
    setShowEditPopup(true);
  };

  const handleCloseEditPopup = () => {
    setShowEditPopup(false);
    setCurrentRole(null);
  };

  const handleDeleteRole = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Role?")) return;
    try {
      const Confiq = Authorization();
      await axios.delete(`${Api}/api/users/roles/${id}`, Confiq);
      setRoles(roles.filter((role) => role._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting roles", err);
    }
  };

  const handleAddRole = (newRole) => { setRoles([...roles, newRole]); };
  const handleEditRole = (updatedRole) => {
    setRoles(roles.map((role) => (role._id === updatedRole._id ? updatedRole : role)));
  };

  const columns = [
    { headerName: "SI.No", field: "serial", width: 100 },
    { headerName: "Role Name", field: "roleName" },
    {
      headerName: "Permissions", field: "permissionsList", width: 800,
      cellRenderer: (params) => params.value.map((p) => `${p}, `).join(""),
    },
    {
      headerName: "Action", field: "action",
      cellRenderer: (params) => (
        <div>
          {permissions.includes("EditRole") && permissions.includes("DeleteRole") && (
            <>
              <i className="mdi mdi-pen" style={{ fontSize: "1.5rem", cursor: "pointer" }}
                onClick={() => handleShowEditPopup(params.data)} />
              <i className="mdi mdi-delete" style={{ fontSize: "1.5rem", cursor: "pointer" }}
                onClick={() => handleDeleteRole(params.data._id)} />
            </>
          )}
        </div>
      ),
    },
  ];

  const tableData = roles.map((role, index) => ({
    ...role,
    serial: index + 1,
    permissionsList: role.permissions.map((p) => p.permissionName),
  }));

  return (
    <div>
      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>User Roles</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>User</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Manage Roles</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-account-key" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Role Records</span>
          {permissions.includes("AddRole") && (
            <button type="button" onClick={handleShowAddPopup}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>
        <div style={{ padding: 16 }}>
          <TableComponent data={tableData} columns={columns} />
        </div>
      </div>

      {showAddPopup && <AddRole onClose={handleCloseAddPopup} onAddRole={handleAddRole} />}
      {showEditPopup && currentRole && (
        <EditRole role={currentRole} onClose={handleCloseEditPopup} onEditRole={handleEditRole} />
      )}
    </div>
  );
};

export default ManageRole;
